import MainFrame from "../../../components/mainFrame";
import { Box, Button, IconButton, TableRow } from "@mui/material";
import styled from "@emotion/styled";
import StickyTable from "../../../components/table";
import Navbar from "../../../components/navbar";
import { Cell } from "../../../components/table/styles";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import AddIcon from "@mui/icons-material/Add";
import { useModal } from "../../../components/modal";
import { DeleteModal } from "../../../components/appbar/modal";
import { smallButton } from "../../../components/Button";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import AddModal from "./modal";
import CoursesMenuItems from "../menuItems";
import { Helmet } from "react-helmet";
import {
  useDeleteSnackMutation,
  useGetSnacksQuery,
} from "../../../app/services/snacks.api";
import { Snack } from "../../../types/snack.api";
import { useState } from "react";
import { PaginationQuery } from "../../../types/query";

const Container = styled(Box)({
  padding: "1rem",
  width: "100%",
  height: "100%",
  minHeight: "90vh",
  maxHeight: "90vh",
});

function Lessons() {
  const { setShow, setContent } = useModal();
  const [query, setQuery] = useState<PaginationQuery>({
    page: 0,
    size: 10,
  });
  const navigate = useNavigate();
  // state is set when coming from the courses list; a page refresh loses it
  const { state } = useLocation() as {
    state: { title: string; courseId: string } | null;
  };
  const courseName = state?.title ?? "";
  const courseId = state?.courseId as string;
  const { data, isLoading, isFetching } = useGetSnacksQuery(
    { courseId, query },
    { skip: !courseId }
  );
  const [deleteSnack] = useDeleteSnackMutation();

  function handleOpenModal(type: string, id?: string) {
    if (type === "edit" && id) {
      setContent({
        title: " ویرایش اسنک",
        body: (
          <AddModal
            courseId={courseId}
            snack={data?.snacks?.entities[id] as Snack}
          />
        ),
      });
    }
    if (type === "add") {
      setContent({
        title: " افزودن اسنک",
        body: <AddModal courseId={courseId} />,
      });
    }
    if (type === "delete" && id) {
      setContent({
        title: "حذف اسنک",
        body: (
          <DeleteModal
            handleDelete={() => {
              deleteSnack({ courseId, snackId: id })
                .unwrap()
                .then(() => setShow(false))
                .catch((err) => {});
            }}
          />
        ),
      });
    }
    setShow(true);
  }
  // opened by URL/refresh without the course id: go back to the list
  if (!courseId) return <Navigate to="/courses" replace />;
  return (
    <Container bgcolor="primary.light">
      <Helmet>
        <title> اسنک ها | پنل ادمین yaadin</title>
      </Helmet>
      <Navbar title={`جلسه‌ها (اسنک‌ها)ی ${courseName} `}>
        <Button
          onClick={() => handleOpenModal("add")}
          sx={[
            smallButton,
            {
              color: "divider",
              borderColor: "divider",
              borderStyle: "solid",
              borderWidth: "1px",
            },
          ]}
        >
          <AddIcon />
          افزودن جلسه / ویدیو
        </Button>
      </Navbar>
      <StickyTable
        headers={[{ name: "عنوان" }, { name: "قفل شده" }, { name: "توضیحات" }]}
        operations={true}
        length={data?.length ?? 0}
        isLoading={isLoading || isFetching}
        onPageQueryChange={(q) => setQuery((p) => ({ ...p, ...q }))}
      >
        {(data?.snacks?.ids || []).map((id, indx) => {
          const snack = data?.snacks?.entities[id] as Snack;
          return (
            <TableRow
              role="checkbox"
              hover
              sx={{
                "&.MuiTableRow-root": {
                  cursor: "pointer",
                },
              }}
              tabIndex={-1}
              key={id}
              onClick={() =>
                navigate(`/${snack._id}/practices`, {
                  state: { title: snack.title },
                })
              }
            >
              <Cell
                sx={{
                  "&.MuiTableCell-root": {
                    color: "divider",
                    fontSize: ".8rem",
                  },
                }}
              >
                {indx + 1}
              </Cell>
              <Cell>{snack.title}</Cell>
              <Cell>{snack.lock ? "قفل شده" : "باز"}</Cell>
              <Cell>{snack.desc}</Cell>
              <Cell
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <IconButton
                  onClick={(e) => {
                    e.stopPropagation();
                    handleOpenModal("edit", snack._id);
                  }}
                >
                  <EditIcon sx={{ color: "divider" }} />
                </IconButton>
                <IconButton
                  onClick={(e) => {
                    e.stopPropagation();
                    handleOpenModal("delete", snack._id);
                  }}
                >
                  <DeleteIcon sx={{ color: "divider" }} />
                </IconButton>
              </Cell>
            </TableRow>
          );
        })}
      </StickyTable>
    </Container>
  );
}

export default MainFrame(Lessons, <CoursesMenuItems />);
